import { useInputs } from '@pages/DiagramsCreateOrEdit/hooks/useInputs'

import { useHandlers } from './useHandlers'

export const useDiagramsCreateOrEdit = () => {
  const { data, handlers, state } = useHandlers()
  const { watch } = state.methods
  const watchTimeline = watch('timeline')
  const watchResources = watch('resources')
  const watchColumns = watch('columns')
  const watchSeries = watch('timeline.series')
  const { handleViewChange, handleChangeSeries } = handlers

  const inputs = useInputs({
    watchSeries,
    watchTimeline,
    watchResources,
    objects: state.objectsOptions,
    viewsOptions: state.viewsOptions,
    handleViewChange,
    handleChangeSeries,
    watchColumns,
  })

  return {
    data,
    state,
    handlers,
    inputs,
  }
}
